// Central content + imagery for Eminence Windows & Doors

export const CONTACT = {
  brand: "Eminence",
  brandFull: "Eminence Windows & Doors",
  phone: "0161 383 8854",
  phoneHref: "tel:01613838854",
  email: "enquiries@eminencewindows.co.uk",
  emailHref: "mailto:enquiries@eminencewindows.co.uk",
  website: "www.eminencewindows.co.uk",
  hours: "9am – 9pm, Mon to Sat",
  address: "Regus, 82 King St, Manchester, M2 4WQ",
  area: "Greater Manchester",
};

export const IMAGES = {
  heroHome:
    "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBob21lJTIwZXh0ZXJpb3IlMjB3aW5kb3dzJTIwZmFjYWRlfGVufDB8fHx8MTc4NDUwMzU5NHww&ixlib=rb-4.1.0&q=85",
  homeExterior:
    "https://images.pexels.com/photos/7598368/pexels-photo-7598368.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  officeFacade:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/lzxbyh5r_image.png",
  officeEntrance:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/degjz23p_image.png",
  officeDusk:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/w6p611eg_image.png",
  bifoldInterior:
    "https://images.unsplash.com/photo-1758565811272-e79917ca0adc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxhbHVtaW5pdW0lMjBiaWZvbGQlMjBkb29ycyUyMG1vZGVybiUyMGRpbmluZyUyMHJvb218ZW58MHx8fHwxNzg0NTA0NTM2fDA&ixlib=rb-4.1.0&q=85",
  install:
    "https://images.unsplash.com/photo-1581578731256-de834a1fc8af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxjcmFmdHNtYW4lMjBpbnN0YWxsaW5nJTIwd2luZG93JTIwaG9tZSUyMGltcHJvdmVtZW50fGVufDB8fHx8MTc4NDUwNDUzNnww&ixlib=rb-4.1.0&q=85",
  doorComposite:
    "https://images.unsplash.com/photo-1559871753-75a00941f6b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwZnJvbnQlMjBkb29yJTIwY29tcG9zaXRlJTIwZW50cmFuY2V8ZW58MHx8fHwxNzg0NTAzNTk0fDA&ixlib=rb-4.1.0&q=85",
  compositeMain:    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/d73w3u66_Designer-Long-Rectangle-e1750851438597.jpg",
  compositeDecoStanley:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/s0rkv82e_Deco-Stanley-Situ.jpg",
  compositeCraftsman:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/0qpuwrpm_Sml-Craftsman-Style-C-Situ.jpg",
  compositeSalisburyPebble:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/moae0xu6_Salisbury-2-Situ.jpg",
  compositeSalisburyBlack:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/borfog02_Salisbury-4-Situ.jpg",
  compositeHornby:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/v8gaf3qg_Hornby-Situ.jpg",
  compositeBrunswick:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/rn9qvnfb_Brunswick-Situ.jpg",
  upvcComo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/pztp590g_Como-One-Harmony-Selena.jpg",
  doorUpvc:
    "https://images.unsplash.com/photo-1510266988780-b681a96dca2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZnJvbnQlMjBkb29yJTIwY29tcG9zaXRlJTIwZW50cmFuY2V8ZW58MHx8fHwxNzg0NTAzNTk0fDA&ixlib=rb-4.1.0&q=85",
  upvcAlnwick:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/0h2q9qy8_Alnwick-One.jpg",
  upvcWindsorSolid:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/dubz7kba_Windsor-Solid.jpg",
  upvcWindsorTwo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/41ubz1zw_Windsor-Two.jpg",
  upvcSunburst:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/xso3npwp_PVC-U-Door-styles3-1.jpg",
  upvcAmalfi:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/s3msbdcm_Amalfi-Four-White.jpg",
  upvcMain:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/9qzerhdl_9368_12_M1_ContemporaryBohemia_v05_New_Light_wood-scaled.webp",
  upvcKensington:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/vbwva2kv_Kensington-Two-Harmony-Verona-Anthracite-Grey.jpg",
  upvcMonaco:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/d05a8mzq_Monaco-One-Harmony-Verona-White.jpg",
  upvcSandringham:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/b1zad6qx_Sandringham-One-Georgian-Bar-New.jpg",
  upvcPortofino:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/i27ox8r7_Portofino-Three-Patterned-Anthracite-Grey.jpg",
  upvcCapri:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/z6pei0yy_Capri-One-Platinum-Prairie-Zinc-Agate-Grey.jpg",
  doorFrench:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/z0tf1g2h_french-Door-1.jpg",
  windowBay:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/lfqu9cmy_Screenshot%202026-07-20%20022901.jpg",
  windowStandard:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_eminence-windows/artifacts/1y53kztm_Screenshot%202026-07-20%20023226.jpg",
  windowExterior:
    "https://images.pexels.com/photos/13137129/pexels-photo-13137129.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  windowInterior:
    "https://images.unsplash.com/photo-1541194577687-8c63bf9e7ee3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxiYXklMjB3aW5kb3clMjBpbnRlcmlvciUyMHN1bmxpZ2h0JTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODQ1MDM1OTR8MA&ixlib=rb-4.1.0&q=85",
};

export const SAVINGS = [
  { amount: "£200", unit: "per window", note: "through our recycling scheme" },
  { amount: "£300", unit: "per door", note: "through our recycling scheme" },
];

// Numbered manifesto (Home trust section)
export const MANIFESTO = [
  {
    n: "01",
    title: "Expert Installation",
    body: "Our skilled installers ensure a perfect fit and a flawless finish on every project, from first survey to final handover.",
  },
  {
    n: "02",
    title: "Energy Efficiency",
    body: "A+ rated, advanced insulated frames and glazing keep your home warmer for longer and help reduce your energy bills.",
  },
  {
    n: "03",
    title: "Enhanced Security",
    body: "Multi-point locking systems and toughened glass give you and your family complete peace of mind, day and night.",
  },
  {
    n: "04",
    title: "Low Maintenance",
    body: "Durable materials built to last with minimal upkeep — no rot, no fade, just a simple wipe to keep them looking new.",
  },
  {
    n: "05",
    title: "Dependable Aftercare",
    body: "We're here for you long after installation with genuine, dependable support whenever you need it.",
  },
];

export const BENEFIT_ICONS = [
  { icon: "leaf", label: "A+ Energy Rated" },
  { icon: "shield-check", label: "Enhanced Security" },
  { icon: "sparkles", label: "Low Maintenance" },
  { icon: "credit-card", label: "Finance Available" },
];

export const DOORS = [
  {
    slug: "composite",
    name: "Composite Doors",
    image: IMAGES.compositeMain,
    tagline: "Engineered for strength, security and style.",
    overview:
      "Our premium composite doors combine a solid, insulated core with a hard-wearing outer skin for outstanding durability. A wide choice of colours, finishes and glass designs lets you create an entrance that's unmistakably yours.",
    benefits: [
      "Multi-point locking, Secure by Design",
      "Weather tested to perform in all conditions",
      "Wide range of colours & woodgrain finishes",
      "Backed by our 10-year guarantee",
    ],
    colours: [
      { name: "Duck Egg Blue", glass: "Monterey Glass" },
      { name: "Anthracite Grey", glass: "Ohio Glass" },
      { name: "Chartwell Green", glass: "Element Glass" },
      { name: "Agate Grey", glass: "Prairie Zinc Glass" },
    ],
  },
  {
    slug: "upvc",
    name: "uPVC Doors",
    image: IMAGES.upvcMain,
    tagline: "Contemporary designs, effortless upkeep.",
    overview:
      "Our modern uPVC doors deliver excellent durability and thermal performance at exceptional value. Available in a variety of colours and finishes, they're a low-maintenance choice that keeps its good looks year after year.",
    benefits: [
      "Excellent durability & thermal performance",
      "Low maintenance — simply wipe clean",
      "Available in a variety of colours & finishes",
      "Secure, robust multi-point locking",
    ],
    colours: [],
  },
  {
    slug: "french",
    name: "French Doors",
    image: IMAGES.doorFrench,
    tagline: "Open your home to light and garden.",
    overview:
      "Elegant French doors flood your rooms with natural light and create a beautiful connection to your garden or patio. Slim, refined frames and dual-opening leaves make them a timeless choice for any home.",
    benefits: [
      "Wide, dual-opening access to outdoor space",
      "Floods interiors with natural light",
      "Slim frames with toughened, energy-efficient glass",
      "Secure locking for total peace of mind",
    ],
    colours: [],
  },
];

export const COMPOSITE_GALLERY = [
  { name: "Deco Stanley", finish: "Chartwell Green", image: IMAGES.compositeDecoStanley },
  { name: "Craftsman Style", finish: "Anthracite Grey", image: IMAGES.compositeCraftsman },
  { name: "Salisbury", finish: "Pebble Grey", image: IMAGES.compositeSalisburyPebble },
  { name: "Salisbury", finish: "Black", image: IMAGES.compositeSalisburyBlack },
  { name: "Hornby", finish: "Irish Oak", image: IMAGES.compositeHornby },
  { name: "Brunswick", finish: "Cream", image: IMAGES.compositeBrunswick },
];

export const UPVC_GALLERY = [
  { name: "Kensington Two", finish: "Anthracite Grey", image: IMAGES.upvcKensington },
  { name: "Monaco One", finish: "White", image: IMAGES.upvcMonaco },
  { name: "Sandringham One", finish: "Georgian Bar", image: IMAGES.upvcSandringham },
  { name: "Portofino Three", finish: "Anthracite Grey", image: IMAGES.upvcPortofino },
  { name: "Capri One", finish: "Agate Grey", image: IMAGES.upvcCapri },
  { name: "Como One", finish: "White", image: IMAGES.upvcComo },
];

export const WINDOWS = [
  {
    slug: "standard",
    name: "Windows in Every Style & Colour",
    image: IMAGES.windowStandard,
    tagline: "Made-to-measure, in any finish.",
    overview:
      "Choose from a range of made-to-measure window styles, including casement, tilt-and-turn and sliding options. Available in classic white, popular Anthracite Grey, and a selection of colour and woodgrain finishes to complement your property.",
    benefits: [
      "Casement, tilt-and-turn and sliding styles",
      "Excellent ventilation and easy cleaning",
      "Choice of colours including Anthracite Grey",
      "Energy-efficient, secure and low maintenance",
    ],
  },
  {
    slug: "bay",
    name: "Bay Windows",
    image: IMAGES.windowBay,
    tagline: "Add space, light and character.",
    overview:
      "Bay windows create a striking focal point while adding a real sense of space and light to any room. Combining timeless design with modern performance, they're a versatile way to transform how a room looks and feels.",
    benefits: [
      "Adds space, light and character to any room",
      "Timeless design with modern performance",
      "Energy-efficient, insulated frames",
      "Choose from a range of openings and designs to suit you",
    ],
  },
];
